
var Model = require("../types/Model");
var Promise = require("promise");

module.exports = Model({
	name: "usercreation",
	init: init,
	triggers: triggers,

	submitCreate: submitCreate,
	submitUpdate: submitUpdate,
	cancel: cancel,
	handle_created: handle_created,
	handle_error: handle_error,
	createError: createError
});

function init(){
	this._editing = false;
	this.push(null);
}

function triggers(){
	return {
		view: view,
		edit: edit,
		cancel: cancel,
		submit: submit
	};
}

function view(){
	this.dispatch("viewing");
	this.emit("usermetrics:trigger:track", "view user creation");
}

function edit(who){
	this._editing = who;
	var mobilePatient = who.type.indexOf("user:mobile") !== -1;
	if(mobilePatient)
		who.byemail = true;
	who.manageGroup = getAsArray(who.manage_group);
	this.push(who);
	this.dispatch("viewing");
	this.emit("usermetrics:trigger:track", "open edit user in user creation", {
		who: who._id,
	});
}

function cancel(){
	var editing = this._editing;
	if(editing){
		this.emit("usermetrics:trigger:track", "cancel user edit", {
			userId: editing
		});
		this._editing = false;
		this.push(null);
	} else {
		this.emit("usermetrics:trigger:track", "cancel user creation");
	}
	this.dispatch("cancel");
}

function handle_created(id){
	var editing = this._editing;
	if(editing){
		this.emit("usermetrics:trigger:track", "user creation updated", {
			userId: editing
		});
		this._editing = false;
		this.push(null);
	} else {
		this.emit("usermetrics:trigger:track", "user created", {
			userId: id
		});
	}
	this.dispatch("cancel");
}

function submit(data){
	var editing = this._editing;
	if(editing) {
		this.emit("usermetrics:trigger:track", "submit edit user in user creation", {
			who: editing._id,
		});
		this.submitUpdate(data);
	}
	else {
		this.emit("usermetrics:trigger:track", "submit create user in user creation", {
			who: editing._id,
		});
		this.submitCreate(data);

	}
}

function submitCreate(data){
	var byEmail = data.byemail;
	var managers = data.managers;
	var patientNumber = data.patientNumber;
	var manageGroup = data.manageGroup;
	var language = data.language;
	var userType = data.userType;
	var user_note = data.user_note;

	if (!language) {
		this.createError("Missing language");
		return;
	}

	if (user_note && user_note.length > 30) {
		this.createError("User note is too long");
		return;
	}

	if (byEmail) {
		var email = data.email;
		if (!email) {
			this.createError("Missing email");
			return;
		}
		return this.api.org.users.invitation.send(email, managers, "", "", patientNumber, manageGroup, language, user_note)
			.catch(handle_error.bind(this))
			.then(cancel.bind(this));
	} else {
		var fname = data.fname;
		var lname = data.lname;
		if (!fname || !lname) {
			this.createError("Missing names");
			return;
		}
		let createHandler = this.api.org.users.create;
		if (userType === "Mobile") {
			createHandler = this.api.org.users.createMobile;
		} else if (userType === "Simplified") {
			createHandler = this.api.org.users.createSimplified;
		}
		return createHandler(fname, lname, patientNumber, managers, language, user_note)
			.then(updateManageGroup.bind(this, manageGroup))
			.then(handle_created.bind(this))
			.catch(handle_error.bind(this));
	}
}

function submitUpdate(data){
	var patientNumber = data.patientNumber;
	var manageGroup = data.manageGroup;
	var editing = this._editing;
	var fname = data.fname;
	var lname = data.lname;
	var user_note = data.user_note;

	if (!fname || !lname) {
		this.createError("Missing names");
		return;
	}

	if (user_note && user_note.length > 30) {
		this.createError("User note is too long");
		return;
	}

	if(data.userType !== editing.userType) {
		this.api.org.users.typeUpdate(editing._id, data.userType.toLowerCase())
			.catch(handle_error.bind(this));
	}

	if(manageGroup === editing.manage_group)
		manageGroup = null;

	if(patientNumber === editing.patientNumber)
		patientNumber = null;

	var result = {
		id: editing._id
	};

	return this.api.org.users.update(editing._id, data)
		.then(updatePatientNumber.bind(this, patientNumber, editing._id))
		.then(updateManageGroup.bind(this, manageGroup, result))
		.catch(handle_error.bind(this))
		.then(handle_created.bind(this));
}

function manageGroupsUpdates(prevManageGroups, newManageGroups) {
	const currManageGroups = getAsArray(prevManageGroups);
	const updatedManageGroups = getAsArray(newManageGroups);

	const groupsToRemove = currManageGroups.filter((currGroup) => {
		if (!currGroup) return false;
		return updatedManageGroups.indexOf(currGroup) <= -1;
	});
	const groupsToAdd = updatedManageGroups.filter((newGroup) => {
		if (!newGroup) return false;
		return currManageGroups.indexOf(newGroup) <= -1;
	});
	return { groupsToRemove, groupsToAdd };
}

function updateManageGroup(group, {id}){
	const { groupsToRemove, groupsToAdd } = manageGroupsUpdates(this._editing.manage_group, group);
	const removeGroupPromise = groupsToRemove.length > 0
		? this.api.org.managergroups.removeGroup(id, groupsToRemove)
		: Promise.resolve();
	const assignGroupPromise = groupsToAdd.length > 0
		? this.api.org.managergroups.assignGroup(id, groupsToAdd)
		: Promise.resolve();

	return Promise.all([
		removeGroupPromise,
		assignGroupPromise,
	]).then(()=>{
		return id;
	}).catch(handle_error.bind(this));
}

function updatePatientNumber(patientNumber, who){
	if(!patientNumber) return Promise.resolve();
	return this.api.org.users.careplan.number.update(who, patientNumber);
}

function createError(message){
	var err = {
		response: {
			message: message
		}
	};
	this.handle_error(err);
}

function handle_error(err){
	var response = err.response;
	var errMessage = response.message;
	var message = "usercreation.errorcreate";
	if(errMessage === "User already in group")
		message = "usercreation.errorcareplan";
	else if(errMessage === "Missing names")
		message = "usercreation.missingnames";
	else if(errMessage === "User note is too long")
		message = "usercreation.user_note_error";
	else if(errMessage === "Missing email")
		message = "usercreation.missingemails";
	else if(errMessage === "Missing language")
		message = "usercreation.missinglanguage";
	else if(errMessage === "Must specify which manager should be added"){
		message = "usercreation.errormanager";
		this.cancel();
	} else if(this._editing)
		message = "usercreation.errorupdate";
	
	this.emit("usermetrics:trigger:track", "failed to create user", {
		errMessage
	});

	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function getAsArray(value) {
	if (value === null || value === undefined) return [];
	if (Array.isArray(value)) return value;
	return [value];
}
